import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {AnyToDo} from '../../../typings/todo';
import {ShareButtonsContainer} from '../../containers/ShareButtonsContainer/ShareButtonsContainer';
import {SmallParagraph} from '../ui/SmallParagraph/SmallParagraph';
import {Subtitle} from '../ui/Subtitle/Subtitle';
import {Title} from '../ui/Title';
import {GetAlbumButton} from './GetAlbumButton/GetAlbumButton';
import {GetTrackButton} from './GetTrackButton/GetTrackButton';
import styles from './TrackInfo.scss';

export class TrackInfo extends React.Component<AnyToDo> {
  static propTypes = {
    album: PropTypes.object,
    track: PropTypes.object,
    onGetAlbumButtonClick: PropTypes.func,
    onGetTrackButtonClick: PropTypes.func,
  };

  render() {
    const {album, track, onGetAlbumButtonClick, onGetTrackButtonClick} = this.props;
    const trackLyrics = (track.trackLyrics || '').trim();
    const albumDetails = (album.albumDetails || '').trim();
    const className = classNames(styles.trackInfo, {
      [styles.hasTrackLyrics]: Boolean(trackLyrics),
      [styles.hasAlbumDetails]: Boolean(albumDetails),
    });

    return (
      <div className={className}>
        <ShareButtonsContainer
          className={styles.shareButtonsContainerTop}
          album={album}
          track={track}
          isDisabled={album.demo}
          withText
        />
        <Title className={styles.title}>{track.trackName}</Title>
        <Subtitle className={styles.subTitle}>
          {track.artistName} / {album.albumName}
        </Subtitle>
        <div className={styles.buttonContainer}>
          <GetAlbumButton className={styles.getAlbumButton} album={album} onClick={onGetAlbumButtonClick} />
          <GetTrackButton
            className={styles.getTrackButton}
            album={album}
            track={track}
            onClick={onGetTrackButtonClick}
          />
          <ShareButtonsContainer
            className={styles.shareButtonsContainer}
            album={album}
            track={track}
            isDisabled={album.demo}
          />
        </div>
        <SmallParagraph className={styles.trackLyrics} dataHook="track-lyrics">
          {trackLyrics}
        </SmallParagraph>
        <hr className={styles.separator} data-hook="info-separator" />

        <SmallParagraph className={styles.albumDetails} dataHook="album-details">
          {albumDetails}
        </SmallParagraph>
      </div>
    );
  }
}
